import {
  Select as ChakraSelect,
  SelectProps as ChakraSelectProps,
} from '@chakra-ui/react';
import React from 'react';

export enum SelectVariant {
  FILLED_BLUE = 'filledBlue',
  FILLED_WHITE = 'filledWhite',
  FILLED = 'filled',
  OUTLINE = 'outline',
  OUTLINE_WHITE = 'outlineWhite',
  UNSTYLED = 'unstyled',
  FLUSHED = 'flushed',
}

interface SelectOptionProps {
  label: string;
  value: string | number;
  selected?: boolean;
}

interface SelectProps
  extends Pick<
    ChakraSelectProps,
    | 'bg'
    | 'color'
    | 'onChange'
    | 'onBlur'
    | 'isRequired'
    | 'isDisabled'
    | 'value'
    | 'width'
  > {
  name: string;
  options: SelectOptionProps[];
  variant?: SelectVariant;
  placeholder?: string;
  style?: React.CSSProperties;
}

//TODO: There is a good chance this wont end up in the design-library
// atleast in its current state
const Select: React.FC<SelectProps> = ({
  name,
  options,
  variant = SelectVariant.FILLED_BLUE,
  placeholder,
  children,
  ...rest
}) => {
  return (
    <ChakraSelect
      variant={variant}
      placeholder={placeholder}
      name={name}
      {...rest}
    >
      {options?.map(({ value, label, selected }) => (
        <option key={value} value={value} selected={selected}>
          {label}
        </option>
      ))}
    </ChakraSelect>
  );
};

export default Select;
